module.exports = __webpack_public_path__ + "img/ag_gallery_3.2a5048b8.jpg";